import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_ADMIN_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_USERS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY,
} from '@/swagger/constants/contents-likes-keys';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_CONTENTID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY,
} from '@/swagger/constants/contents-orchestrator-keys';
import { ContentLike } from '../types';

export const API_POST_CONTENTS_LIKES = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY, {
    organizationId,
  });
};

export const API_GET_CONTENTS_LIKES = (organizationId: string, contentType: ContentLike) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl({ contentType }, baseUrl);
};

export const API_DELETE_CONTENTS_LIKES = (organizationId: string, contentHash: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_PATH_KEY, {
    organizationId,
    contentHash,
  });
};

export const API_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE = (
  organizationId: string,
  contentType: ContentLike,
) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_ADMIN_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl({ contentType }, baseUrl);
};

export const API_GET_ADMIN_CONTENTS_LIKES_USERS = (organizationId: string, contentHash: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_USERS_PATH_KEY,
    {
      organizationId,
      contentHash,
    },
  );
};

export const API_PUT_CONTENTS_FAVORITES = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY, {
    organizationId,
  });
};

export const API_DELETE_CONTENTS_FAVORITES = (organizationId: string, contentId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_CONTENTID_PATH_KEY,
    {
      organizationId,
      contentId,
    },
  );
};
